import { Model, modelRegistry } from './Model';
import { Product } from '.';
export class DispatchItem extends Model {
    static entity = 'dispatch_items';
    id = null;
    dispatch_id = null;
    product_id = null;
    count = '0.000';
    created_at = null;
    updated_at = null;
    product;
    static fields() {
        return {
            id: this.attr(null),
            dispatch_id: this.attr(null),
            product_id: this.attr(null),
            count: this.attr('0.000', value => this.round(value, 3).toFixed(3)),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            product: this.attr(undefined, value => value ? new Product(value) : undefined),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    getCount() {
        return parseFloat(this.count);
    }
    getProduct() {
        if (this.product)
            return this.product;
        return Product.find(this.product_id);
    }
}
export default DispatchItem;
modelRegistry.register('DispatchItem', DispatchItem);
//# sourceMappingURL=DispatchItem.js.map